import * as React from 'react';
import { CheckMarkIcon } from '../../../components/Icons/CheckMarkIcon';
import * as Colors from '../../../consts/variables';
import { INewsletterBenefitItem } from '../../../interfaces/INewsletter';

interface IProps {
    benefits: INewsletterBenefitItem[];
    baseStyleClass: string;
}

const styles: Record<string, React.CSSProperties> = {
    checkMarkListIcon: {
        marginRight: 5,
        fill: Colors.acqa,
        flex: '0 0 auto',
        alignSelf: 'flex-start',
    },
    checkMarkListLabel: {
        marginTop: 2,
        color: Colors.white,
        fontWeight: 'bold',
        textAlign: 'left',
    },
};

export const CheckMarkList = (props: IProps) => {
    const getBenefitList = () =>
        props.benefits.map((item, index) => {
            return item.benefit && item.benefit.length > 0 ? (
                <div className="checkMarkWrapper--list-item" key={index}>
                    <CheckMarkIcon width={30} height={30} style={styles.checkMarkListIcon} />
                    <span style={styles.checkMarkListLabel}>{item.benefit}</span>
                </div>
            ) : null;
        });
    return (
        <div className="checkMarkWrapper">
            <div className="checkMarkWrapper--list">{getBenefitList()}</div>
        </div>
    );
};
